import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGroupOutline = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Group Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M.6191 12.817v-.6255c0-2.4183 1.9605-4.3787 4.3788-4.3787h0c2.4183 0 4.3787 1.9604 4.3787 4.3787v.6255"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M8.1255 9.0638h0c0-1.7273 1.4004-3.1276 3.1277-3.1276h0c1.7274 0 3.1277 1.4003 3.1277 3.1276v.3128"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.9979 7.8128C6.3798 7.8128 7.5 6.6925 7.5 5.3106c0-1.3818-1.1202-2.5021-2.5021-2.5021S2.4958 3.9288 2.4958 5.3106s1.1202 2.5022 2.502 2.5022M11.2532 5.9362c1.0364 0 1.8766-.8402 1.8766-1.8766s-.8402-1.8766-1.8766-1.8766-1.8766.8402-1.8766 1.8766.8401 1.8766 1.8766 1.8766"
    />
  </svg>
);
export default SvgGroupOutline;
